/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const ProcessesSortByDto = {
    CreatedBy: 'CREATED_BY',
    Date: 'DATE',
    ExternalProcessId: 'EXTERNAL_PROCESS_ID',
    Name: 'NAME',
    OrdinalNumber: 'ORDINAL_NUMBER',
    Requirements: 'REQUIREMENTS',
    Status: 'STATUS',
} as const;

export type ProcessesSortByDto = typeof ProcessesSortByDto[keyof typeof ProcessesSortByDto];



